module.exports = __webpack_public_path__ + "img/xyzg.dedb6aab.jpg";